// This file is the entry point for Webpack, along with any other pack files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within /client and only use these pack files to create entry points.
// Load SCSS in /client/stylesheets/application.scss
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
// Import legacy components from legacy.js
import BackOffRefresher from "legacy/BackOffRefresher"
import FavoriteButton from "legacy/FavoriteButton"
import FormToggle from "legacy/FormToggle"
import PackagingMarketing from "legacy/PackagingMarketing"
import PaginateCharges from "legacy/PaginateCharges"
import AssignmentsV2Controller from "legacy/assignments-v2/AssignmentsV2Controller"
import AssignmentsController from "legacy/assignments/AssignmentsController"
import AssignmentsWithoutSpaces from "legacy/assignments/AssignmentsWithoutSpaces"
import AuthSignUpKiosk from "legacy/auth/AuthSignUpKiosk"
import SignUpLauncher from "legacy/auth/SignUpLauncher"
import AddBankAccountModal from "legacy/bank-account/AddBankAccountModal"
import PayoutScheduleModal from "legacy/bank-account/PayoutScheduleModal"
import BoaterTermsModal from "legacy/boater-life/BoaterTermsModal"
import BoaterBookingForm from "legacy/boater-reservation-flow/BoaterBookingForm"
import CancelReservationModal from "legacy/boater-reservation-flow/CancelReservationModal"
import MbmPricingEstimate from "legacy/boater-reservation-flow/MbmPricingEstimate"
import ShareReservationModal from "legacy/boater-reservation-flow/ShareReservationModal"
import ChangeReservationPaymentController from "legacy/change-reservation-payment/ChangeReservationPaymentController"
import ReservationChargeItemModal from "legacy/charge-item/ReservationChargeItemModal"
import ContractGroupShowV2Controller from "legacy/contract-groups-v2/ContractGroupShowV2Controller"
import ContractGroupV2Controller from "legacy/contract-groups-v2/ContractGroupV2Controller"
import ContractTableV2 from "legacy/contract-groups-v2/ContractTableV2"
import InquiryForm from "legacy/contract-quote/InquiryForm"
import CreditCardModal from "legacy/credit-cards/CreditCardModal"
import EditCreditCardModal from "legacy/credit-cards/EditCreditCardModal"
import SelectAndAddPaymentMethodModal from "legacy/credit-cards/SelectAndAddPaymentMethodModal"
import EmbeddedInquiryShow from "legacy/inquiries/EmbeddedInquiryShow"
import InquiryActionsButton from "legacy/inquiries/InquiryActionsButton"
import AddAdjustmentFeesModal from "legacy/manage/AddAdjustmentFeesModal"
import DisableAutoRenewModal from "legacy/manage/DisableAutoRenewModal"
import EditDiscountsModal from "legacy/manage/EditDiscountsModal"
import EditReservationModal from "legacy/manage/EditReservationModal"
import EditTransientReservationModal from "legacy/manage/EditTransientReservationModal"
import EmailValidation from "legacy/manage/EmailValidation"
import LoaMigrationModal from "legacy/manage/LoaMigrationModal"
import ManualRefund from "legacy/manage/ManualRefund"
import MarinaTermsModal from "legacy/manage/MarinaTermsModal"
import RefundBalanceApplicationSettleButton from "legacy/manage/RefundBalanceApplicationSettleButton"
import RefundDistributionModal from "legacy/manage/RefundDistributionModal"
import RefundPaymentIntentModal from "legacy/manage/RefundPaymentIntentModal"
import ReservationItinerarySection from "legacy/manage/ReservationItinerarySection"
import ReservationLabelSelect from "legacy/manage/ReservationLabelSelect"
import ReservationLabelsController from "legacy/manage/ReservationLabelsController"
import ReservationNightsSection from "legacy/manage/ReservationNightsSection"
import ReservationStatusHeader from "legacy/manage/ReservationStatusHeader"
import SettlePaymentModal from "legacy/manage/SettlePaymentModal"
import SpaceGroupModal from "legacy/manage/SpaceGroupModal"
import RefundModal from "legacy/manage/cancel/RefundModal"
import AvailabilitySummary from "legacy/manage/dashboard/AvailabilitySummary"
import DashboardController from "legacy/manage/dashboard/DashboardController"
import ListedPumpPricesForm from "legacy/manage/dashboard/ListedPumpPricesForm"
import MapController from "legacy/map/MapController"
import MarinaMapAnnotationController from "legacy/marina-map/MarinaMapAnnotationController"
import MarinaSearchController from "legacy/marina-search/MarinaSearchController"
import ReviewController from "legacy/marinascom-review/ReviewController"
import NamedDiscountsTable from "legacy/named_discounts/NamedDiscountsTable"
import Availability from "legacy/new-reservation-form/Availability"
import NewReservationWizard from "legacy/new-reservation-form/NewReservationWizard"
import PaymentAuthController from "legacy/payment-auth/PaymentAuthController"
import PreservedRateModalButton from "legacy/preserved_rates_table/PreservedRateModalButton"
import PricingController from "legacy/pricing/PricingController"
import AccrualAccountingExport from "legacy/reports/AccrualAccountingExport"
import Export from "legacy/reports/Export"
import LegacyExportButton from "legacy/reports/ExportButton"
import ReportToggle from "legacy/reports/ReportToggle"
import SunsettingAccountingReportAlert from "legacy/reports/SunsettingAccountingReportAlert"
import SaleAccountList from "legacy/sales/SaleAccountList"
import SalesContainer from "legacy/sales/SalesContainer"
import React from "react"
import ReactOnRails from "react-on-rails"
import ExampleComponent from "src/ExampleComponent"
import consumer from "src/channels"
import Boats from "src/main/Account/Boats"
import BoatDetails from "src/main/Account/Boats/BoatDetails"
// Import migrated components directly
import Favorites from "src/main/Account/Favorites"
import Inquiries from "src/main/Account/Inquiries"
import Invoices from "src/main/Account/Invoices"
import PaymentMethodsContainer from "src/main/Account/PaymentMethods/PaymentMethodsContainer"
import PayInvoice from "src/main/Account/PaymentPortal/PayInvoice"
import Autopay from "src/main/Account/Reservations/Autopay"
import BillingDetails from "src/main/Account/Reservations/BillingDetails"
import IosLoginAndSecurityWebview from "src/main/Account/Settings/IosLoginAndSecurityWebview"
import SettingsRouter from "src/main/Account/Settings/SettingsRouter"
import Trips from "src/main/Account/Trips"
import AccountSaleDetails from "src/main/Account/Trips/Sales/Details"
import AccountingRouter from "src/main/Accounting"
import SpotterAnalytics from "src/main/Analytics/SpotterAnalytics"
import ThoughtSpotAnalytics from "src/main/Analytics/ThoughtSpotAnalytics"
import BarcodeScannerTest from "src/main/BarcodeScannerTest"
import Billing from "src/main/Billing"
import CancelContractModal from "src/main/Billing/CancelContractModal"
import EditPendingReservation from "src/main/Billing/EditPendingReservation"
import InvoicePrintView from "src/main/Billing/InvoicePrintView"
import BoatPhoto from "src/main/BoaterProfile/BoatPhoto/BoatPhoto"
import ContactInfoForm from "src/main/BoaterProfile/ContactInfoForm"
import HomeportPromptsModal from "src/main/BoaterProfile/HomeportPrompts/HomeportPromptsModal"
import HomeportSelectField from "src/main/BoaterProfile/HomeportSelectField/HomeportSelectField"
import IncompleteBoatProfileMessage from "src/main/BoaterProfile/IncompleteBoatProfileMessage/IncompleteBoatProfileMessage"
import ChatContainer from "src/main/Chat/ChatContainer"
import Contacts from "src/main/Contact"
import ContactBoatPhoto from "src/main/Contact/ContactBoatPhoto"
import ContactMessagesTab from "src/main/Contact/ContactMessagesTab"
import ContactWaitlistEntries from "src/main/Contact/ContactWaitlistEntries"
import ContactInvoicesPanel from "src/main/ContactInvoicesPanel"
import ContractGroup from "src/main/Contracts/ContractGroup"
import ContractsForm from "src/main/Contracts/ContractsForm/ContractsFormContext"
import ManageContracts from "src/main/Contracts/ManageContracts"
import ContractQuoteEntryActionsDropdown from "src/main/Contracts/ManageContracts/Components/ContractQuoteEntryActionsDropdown"
import MbmContractsAnnouncementBanner from "src/main/Contracts/ManageContracts/Components/MbmContractsAnnouncementBanner"
import DocusealTemplateBuilder from "src/main/Contracts/ManageContracts/DocusealTemplateBuilder"
import ContractSubmitted from "src/main/Contracts/SignContract/ContractSubmitted"
import SignContractEntry from "src/main/Contracts/SignContract/SignContractEntry"
import SignContractWizardContainer from "src/main/Contracts/SignContract/SignContractWizardContainer"
import SignInHouseContract from "src/main/Contracts/SignInHouseContract"
import CruisePlan from "src/main/CruisePlans/CruisePlan"
import CruisePlanIndexEmptyState from "src/main/CruisePlans/CruisePlanIndexEmptyState"
import LocationStopForm from "src/main/CruisePlans/LocationStopForm"
import MarinaStopForm from "src/main/CruisePlans/MarinaStopForm"
import NoteStopForm from "src/main/CruisePlans/NoteStopForm"
import ReservationStopForm from "src/main/CruisePlans/ReservationStopForm"
import DashboardContainer from "src/main/Dashboard/DashboardContainer"
import OptInBanner from "src/main/Dashboard/OptInBanner"
import ManageDockwaPlusDeals from "src/main/DockwaPlusDeals/Manage"
import FuelDiscountForm from "src/main/DockwaPlusDeals/Manage/Fuel/FuelDiscountForm"
import DockwaPlusDealsMarketing from "src/main/DockwaPlusDeals/Marketing"
import AllDeals from "src/main/DockwaPlusDeals/Marketing/AllDeals"
import DealsList from "src/main/DockwaPlusDeals/Marketing/DealsList"
import DockwaPlusDealsBanner from "src/main/DockwaPlusDeals/Marketing/DockwaPlusDealsBanner"
import ImportDetails from "src/main/DromoImports/ImportDetails"
import Imports from "src/main/DromoImports/Imports"
import LaunchShow from "src/main/DryStack/Boater/LaunchShow"
import LaunchesContainer from "src/main/DryStack/Boater/LaunchesContainer"
import LaunchNotificationBadge from "src/main/DryStack/MarinaSchedule/LaunchNotificationBadge"
import MarinaScheduleContainer from "src/main/DryStack/MarinaSchedule/MarinaScheduleContainer"
import DryStackSettingsContainer from "src/main/DryStack/Settings/DryStackSettingsContainer"
import Fuel from "src/main/Fuel"
import ManageInquiries from "src/main/Inquiries"
import InsightsContainer from "src/main/Insights/InsightsContainer"
import Integrations from "src/main/Integrations"
import LongTermWaitlistCTA from "src/main/LongTermWaitlist/boater/LongTermWaitlistCTA"
import LongTermWaitlistEntryShow from "src/main/LongTermWaitlist/boater/LongTermWaitlistEntryShow"
import BoaterLongtermWaitlistFormPage from "src/main/LongTermWaitlist/boater/WaitlistForm"
import LongTermWaitlistEntriesRouter from "src/main/LongTermWaitlist/marina/LongTermWaitlistEntriesRouter"
import NightViewPage from "src/main/Manage/NightView"
import ReservationNightTable from "src/main/Manage/ReservationNightTable"
import ItemFormContainer from "src/main/ManageItems/Form/ItemFormContainer"
import ManageItemsContainer from "src/main/ManageItems/ManageItemsContainer"
import MarinaClaimSelector from "src/main/MarinaClaimSelector"
import MarinaInvite from "src/main/MarinaInvite"
import DockwaPlusDeals from "src/main/MarinaProfile/DockwaPlusDeals"
import FuelSection from "src/main/MarinaProfile/Fuel"
import MarinaReviewForm from "src/main/MarinaReviewForm"
import MarinaSubscription from "src/main/MarinaSubscription"
import MarinaSwitcher from "src/main/MarinaSwitcher"
import MarinaTaxesController from "src/main/MarinaTaxes/MarinaTaxesController"
import MeteredElectricContainer from "src/main/MeteredElectric/MeteredElectricContainer"
import MeteredElectricSettings from "src/main/MeteredElectric/Settings/MeteredElectricSettings"
import CalendarContainer from "src/main/Occupancy/CalendarContainer"
import OnboardingContainer from "src/main/Onboarding/Claim/OnboardingContainer"
import ReceiptConfiguration from "src/main/PaperReceipts/ReceiptConfiguration"
import ReceiptPreview from "src/main/PaperReceipts/ReceiptPreview"
import PaymentsContainer from "src/main/Payments/PaymentsContainer"
import PointOfSaleLayoutEditor from "src/main/PointOfSale/LayoutEditor"
import PointOfSale from "src/main/PointOfSale/Router"
import Sales from "src/main/PointOfSale/Sales"
import SaleDetails from "src/main/PointOfSale/Sales/SaleDetails"
import ContactSaleHistoryTable from "src/main/PointOfSale/Sales/SaleHistory/ContactSaleHistoryTable"
import PhotoContainer from "src/main/PublicProfile/Photos/PhotoContainer"
import PublicProfilePublicationStatus from "src/main/PublicProfile/PublicProfilePublicationStatus"
import AccountingIntegrationAnnouncementBanner from "src/main/Reports/AccountingIntegrationAnnouncementBanner"
import Reservations from "src/main/Reservations"
import DismissibleAnnouncementBanner from "src/main/Reservations/DismissibleAnnouncementBanner"
import ExportButton from "src/main/Reservations/ExportButton"
import ReplaceContractAgreement from "src/main/Reservations/ReplaceContractAgreement"
import ReservationSettings from "src/main/Reservations/Settings"
import ReviewContainer from "src/main/Reviews/ReviewContainer"
import JobTemplates from "src/main/Service/Manage/JobTemplates"
import JobTemplate from "src/main/Service/Manage/JobTemplates/JobTemplate"
import WorkOrders from "src/main/Service/Manage/WorkOrders"
import WorkOrder from "src/main/Service/Manage/WorkOrders/WorkOrder"
import General from "src/main/Settings/General"
import BoaterPayNow from "src/main/Settings/General/BoaterPayNow"
import AdvancedReceiptsSettings from "src/main/Settings/Hardware/AdvancedReceiptsSettings"
import TipSettings from "src/main/Settings/Hardware/TipSettings"
import PublicProfileFuel from "src/main/Settings/PublicProfile/Fuel"
import StripeConnectSettingsContainer from "src/main/Settings/StripeConnect"
import CalendarDaysTable from "src/main/TransientRates/CalendarDaysTable"
import RateStrategyForm from "src/main/TransientRates/RateStrategy"
import TransientReservationWizard from "src/main/TransientReservationWizard"
import CreatePassword from "src/main/User/CreatePassword"
import Login from "src/main/User/Login"
import ResendEmailConfirmation from "src/main/User/ResendEmailConfirmation"
import ResetPassword from "src/main/User/ResetPassword"
import Signup from "src/main/User/Signup"
import ShortTermWaitlistForm from "src/main/Waitlist/ShortTermWaitlistForm"
import WaitlistTopNavigation from "src/main/Waitlist/TopNavigation"
import HeadlessCmsPage from "src/marketing/pages/HeadlessCmsPage"
import "stylesheets/application.scss"
import "trix"

import AddressForm from "src/components/AddressForm"
import AlertBanner from "src/components/AlertBanner"
import BoatPreviewLink from "src/components/BoatPreviewLink"
import MarinaList from "src/components/Card/MarinaList"
import ClickablePhoneNumber from "src/components/ClickablePhoneNumber"
import DockwaAccountIndicator from "src/components/DockwaAccountIndicator"
import ContactPhoneField from "src/components/Form/ContactPhoneField"

import ReactOnRailsProviderWrapper from "src/utils/ReactOnRailsProviderWrapper"

ActiveStorage.start()

// ActionCable for client side code that does not have access to consumer
window.consumer = consumer

// Combined components: migrated from react_component_v2 + legacy components
const allComponents = {
  // Components migrated from react_component_v2 to react_component
  Favorites,
  AccountingIntegrationAnnouncementBanner,
  AccountingRouter,
  AccountSaleDetails,
  AddressForm,
  AdvancedReceiptsSettings,
  AlertBanner,
  AllDeals,
  Autopay,
  BarcodeScannerTest,
  Billing,
  BillingDetails,
  BoatDetails,
  BoatPhoto,
  BoaterLongtermWaitlistFormPage,
  BoaterPayNow,
  Boats,
  CalendarDaysTable,
  CancelContractModal,
  ChatContainer,
  ClickablePhoneNumber,
  ContactBoatPhoto,
  ContactInfoForm,
  Contacts,
  ContactInvoicesPanel,
  ContactMessagesTab,
  ContactPhoneField,
  ContactSaleHistoryTable,
  ContactWaitlistEntries,
  ContractQuoteEntryActionsDropdown,
  ContractSubmitted,
  ContractsForm,
  ContractGroup,
  CalendarContainer,
  OnboardingContainer,
  CreatePassword,
  CruisePlan,
  CruisePlanIndexEmptyState,
  DashboardContainer,
  DealsList,
  DismissibleAnnouncementBanner,
  DockwaAccountIndicator,
  DockwaPlusDealsBanner,
  DockwaPlusDeals,
  DockwaPlusDealsMarketing,
  ManageDockwaPlusDeals,
  DocusealTemplateBuilder,
  Imports,
  ImportDetails,
  DryStackSettingsContainer,
  EditPendingReservation,
  ExampleComponent,
  ExportButton,
  Fuel,
  FuelDiscountForm,
  FuelSection,
  General,
  HeadlessCmsPage,
  HomeportPromptsModal,
  HomeportSelectField,
  IncompleteBoatProfileMessage,
  Inquiries,
  InsightsContainer,
  Integrations,
  InvoicePrintView,
  Invoices,
  ItemFormContainer,
  LaunchShow,
  LaunchesContainer,
  LaunchNotificationBadge,
  LocationStopForm,
  Login,
  LongTermWaitlistCTA,
  LongTermWaitlistEntriesRouter,
  LongTermWaitlistEntryShow,
  ManageInquiries,
  ManageItemsContainer,
  ManageContracts,
  MarinaClaimSelector,
  MarinaInvite,
  MarinaList,
  MarinaReviewForm,
  MarinaStopForm,
  MarinaScheduleContainer,
  MarinaSubscription,
  MarinaSwitcher,
  MarinaTaxesController,
  MbmContractsAnnouncementBanner,
  MeteredElectricContainer,
  MeteredElectricSettings,
  NoteStopForm,
  OptInBanner,
  PayInvoice,
  PaymentMethodsContainer,
  PaymentsContainer,
  PhotoContainer,
  PointOfSale,
  PointOfSaleLayoutEditor,
  PublicProfilePublicationStatus,
  PublicProfileFuel,
  RateStrategyForm,
  ReceiptPreview,
  ReceiptConfiguration,
  ReplaceContractAgreement,
  ResendEmailConfirmation,
  ReservationSettings,
  ReservationStopForm,
  ResetPassword,
  ReviewContainer,
  WorkOrder,
  WorkOrders,
  JobTemplates,
  JobTemplate,
  Sales,
  SaleDetails,
  ShortTermWaitlistForm,
  SignContractEntry,
  SignContractWizardContainer,
  SignInHouseContract,
  SignUpLauncher,
  Signup,
  SpotterAnalytics,
  TipSettings,
  ThoughtSpotAnalytics,
  Trips,
  Reservations,
  ReservationNightTable,
  NightViewPage,
  IosLoginAndSecurityWebview,
  SettingsRouter,
  StripeConnectSettingsContainer,
  TransientReservationWizard,
  WaitlistTopNavigation,

  // Legacy components from legacy.js
  AccrualAccountingExport,
  AddAdjustmentFeesModal,
  AddBankAccountModal,
  AssignmentsController,
  AssignmentsV2Controller,
  AssignmentsWithoutSpaces,
  AuthSignUpKiosk,
  Availability,
  AvailabilitySummary,
  BackOffRefresher,
  BoatPreviewLink,
  BoaterBookingForm,
  BoaterTermsModal,
  CancelReservationModal,
  ChangeReservationPaymentController,
  ContractGroupShowV2Controller,
  ContractGroupV2Controller,
  ContractTableV2,
  CreditCardModal,
  DashboardController,
  DisableAutoRenewModal,
  EditCreditCardModal,
  EditDiscountsModal,
  EditReservationModal,
  EditTransientReservationModal,
  EmailValidation,
  EmbeddedInquiryShow,
  Export,
  LegacyExportButton,
  FavoriteButton,
  FormToggle,
  InquiryActionsButton,
  InquiryForm,
  ListedPumpPricesForm,
  LoaMigrationModal,
  ManualRefund,
  MapController,
  MarinaMapAnnotationController,
  MarinaSearchController,
  MarinaTermsModal,
  MbmPricingEstimate,
  NamedDiscountsTable,
  NewReservationWizard,
  PackagingMarketing,
  PaginateCharges,
  PaymentAuthController,
  PayoutScheduleModal,
  PreservedRateModalButton,
  PricingController,
  RefundBalanceApplicationSettleButton,
  RefundDistributionModal,
  RefundModal,
  RefundPaymentIntentModal,
  ReportToggle,
  ReservationChargeItemModal,
  ReservationItinerarySection,
  ReservationLabelSelect,
  ReservationLabelsController,
  ReservationNightsSection,
  ReservationStatusHeader,
  ReviewController,
  SaleAccountList,
  SalesContainer,
  SelectAndAddPaymentMethodModal,
  SettlePaymentModal,
  ShareReservationModal,
  SpaceGroupModal,
  SunsettingAccountingReportAlert,
}

// Function to wrap a component with the provider wrapper
const wrapWithProviders = (Component, componentName) => {
  // eslint-disable-next-line react/display-name
  return (props) => (
    <ReactOnRailsProviderWrapper
      showReactQueryDevtools={componentName !== "ChatContainer"}
    >
      <Component {...props} />
    </ReactOnRailsProviderWrapper>
  )
}

// Create wrapped versions of all components
const wrappedComponents = {}
Object.entries(allComponents).forEach(([componentName, Component]) => {
  wrappedComponents[componentName] = wrapWithProviders(Component, componentName)
})

// Register all components with ReactOnRails
ReactOnRails.register(wrappedComponents)
